document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.querySelector('[data-vl-menu]');
  const openButton = document.querySelector('[data-vl-menu-open]');
  const closeButtons = document.querySelectorAll('[data-vl-menu-close]');
  const drawerPanel = drawer ? drawer.querySelector('.vl-drawer__panel') : null;
  let lastFocused = null;

  const focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  const menuIsOpen = () => Boolean(drawer && drawer.classList.contains('is-open'));

  const setMenuOpen = (shouldOpen, restoreFocus = true) => {
    if (!drawer || !openButton) return;

    if (shouldOpen) {
      lastFocused = document.activeElement;
    }

    drawer.classList.toggle('is-open', shouldOpen);
    drawer.setAttribute('aria-hidden', shouldOpen ? 'false' : 'true');
    openButton.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
    document.documentElement.classList.toggle('vl-lock', shouldOpen);

    if (shouldOpen) {
      window.requestAnimationFrame(() => {
        const firstTarget = drawerPanel && drawerPanel.querySelector(focusableSelector);
        (firstTarget || drawerPanel || openButton).focus();
      });
    } else if (restoreFocus && lastFocused instanceof HTMLElement) {
      lastFocused.focus();
    }
  };

  if (drawer && openButton) {
    openButton.addEventListener('click', () => setMenuOpen(true));
    closeButtons.forEach((button) => button.addEventListener('click', () => setMenuOpen(false)));
    drawer.querySelectorAll('.vl-drawer__panel a').forEach((link) => {
      link.addEventListener('click', () => setMenuOpen(false, false));
    });

    document.addEventListener('keydown', (event) => {
      if (!menuIsOpen()) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        setMenuOpen(false);
        return;
      }

      if (event.key !== 'Tab' || !drawerPanel) return;
      const focusable = Array.from(drawerPanel.querySelectorAll(focusableSelector));
      if (!focusable.length) {
        event.preventDefault();
        drawerPanel.focus();
        return;
      }

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  const mainProductImage = document.querySelector('[id^="VlProductMainImage-"]');
  const productThumbs = Array.from(document.querySelectorAll('[data-vl-product-thumb]'));

  if (mainProductImage && productThumbs.length) {
    productThumbs.forEach((thumb) => {
      thumb.addEventListener('click', (event) => {
        event.preventDefault();
        mainProductImage.src = thumb.href;
        mainProductImage.removeAttribute('srcset');
        mainProductImage.removeAttribute('sizes');
        mainProductImage.alt = thumb.dataset.imageAlt || mainProductImage.alt;
        productThumbs.forEach((item) => item.setAttribute('aria-current', item === thumb ? 'true' : 'false'));
      });
    });
  }

  const header = document.querySelector('[data-vl-header]');
  if (header) {
    const updateHeader = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    updateHeader();
    window.addEventListener('scroll', updateHeader, { passive: true });
  }
});